export default "__VITE_ASSET__DAiuguLm__"